'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFromBot = undefined;

var _isSenderType = require('./isSenderType');

var _senderTypes = require('../constants/senderTypes');

var isFromBot = exports.isFromBot = (0, _isSenderType.isSenderType)(_senderTypes.BOT);